<template>
  <div :id="'pickup-accessorials' + tripNumber" class="card-accessorials">
    <div
      v-for="(accessorial, index) in accessorialsPickup"
      v-bind:key="accessorial.id"
    >
      <b-form-checkbox
        v-model="selectedAccessorialsPickup[index]"
        value="accepted"
        unchecked-value="not_accepted"
        size="sm"
        @input="selectAccessorial(accessorial, index)"
        class="checkbox-group__checkbox"
      >
        {{ accessorial.accessorial }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AccessorialsPickup",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      selectedAccessorialsPickup: [],
      accessorialsPickup: null,
      user: null,
      newTab: null,
      accessorialsHaul: null,
      currentDepartment: null,
      selectedMode: null
    };
  },
  watch: {
    newTab() {
      this.setAccessorialsListNewTab();
    },
    selectedAccessorialsPickup() {
      return this.$emit("input", this.selectedAccessorialsPickup);
    },
    accessorials() {
      this.setAccessorialsList();
    },
    showSelectedMode(value) {
      this.selectedMode = value;
    }
  },
  computed: {
    ...mapState({
      accessorials: state => state.quotes.accessorials.accessorials
    }),
    ...mapGetters("quotes/quote", ["showSelectedMode"])
  },
  mounted() {
    this.currentDepartment = JSON.parse(
      localStorage.getItem("current-department")
    );
    this.newTab = this.tripNumber;
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    /*  Tener en cuenta si se debe activar o en próximo PR se borra
    if (this.user[0].rol.name == "superuser") {
      document.getElementById(
        `accessorials` + this.tripNumber
      ).style.pointerEvents = "none";
    } */
    this.setAccessorialsList();
    return this.$emit("input", this.selectedAccessorialsPickup);
  },
  updated() {},
  methods: {
    setAccessorialsListNewTab() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response && response !== null) {
        this.accessorialsPickup = response.filter(
          el => el.accessorial_type === "pick up"
        );
      }
    },
    setAccessorialsList() {
      let response = this.$store.getters[
        "quotes/accessorials/showAccessorials"
      ];
      if (response) {
        this.accessorialsPickup = response.filter(
          el => el.accessorial_type === "pick up"
        );
      }
      this.accessorialsHaul = this.$store.getters[
        "quotes/quote/showQuoteById"
      ].haul[this.tripNumber - 1].accessorial;
      for (let accessorial of this.accessorialsHaul) {
        for (let i in this.accessorialsPickup) {
          if (
            accessorial.accessorial.accessorial_type == "pick up" &&
            accessorial.accessorial.name ==
              this.accessorialsPickup[i].accessorial
          ) {
            this.selectedAccessorialsPickup[i] = "accepted";
          }
        }
      }
    },
    selectAccessorial(accessorial, index) {
      let info = {
        body: {},
        params: null
      };
      info.body.haul_ = this.$store.getters["quotes/quote/showQuoteById"].haul[
        this.tripNumber - 1
      ].id;
      info.body.accessorial_ = accessorial.id;
      info.params = this.selectedMode ?? this.showSelectedMode;
      if (this.selectedAccessorialsPickup[index] == "accepted") {
        this.$store.dispatch("quotes/accessorials/checkAccessorial", info);
      } else if (this.selectedAccessorialsPickup[index] == "not_accepted") {
        this.$store.dispatch("quotes/accessorials/uncheckAccessorial", info);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-accessorials {
  height: 100%;
  @include flex-wrap(center);
  flex-direction: row;
}

.checkbox-group {
  &__checkbox {
    text-transform: capitalize;
    margin: 2px 8px !important;
    font-size: 13px !important;
  }
}
</style>
